import { Box, Typography } from '@mui/material';
import categoryBenefitsMap from '../utils/categoryBenefitsMap';

const useStyles = ({ categoryStyle, detailStyle }) => ({
  benefitItem: {
    border: '1px solid #EFF0F7',
    borderRadius: '12px',
    height: '100%',
    padding: '24px',
    backgroundColor: '#FFF',
  },
  benefitsDetailsText: {
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '24px',
    letterSpacing: '-0.43px',
    color: '#646D7A',
    ...detailStyle,
  },
  benefitsCategoryText: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '-0.43px',
    color: '#232B35',
    whiteSpace: 'nowrap',
    marginBottom: '11px',
    ...categoryStyle,
  },
});

const BenefitCard = (props) => {
  const {
    benefit,
    index,
    itemsPerRow,
    categoryStyle = {},
    detailStyle = {},
  } = props;

  const classes = useStyles({ categoryStyle, detailStyle });

  function formatDetails(text) {
    var urlPattern = /(https?:\/\/[^\s]+)/g;
    var cleanedText = text.replace(urlPattern, '');

    cleanedText = cleanedText.substring(0, 250);

    return cleanedText;
  }

  function getMargin(index) {
    if (!itemsPerRow || itemsPerRow <= 0) {
      return '0px';
    }
    const placeInRow = index % itemsPerRow;
    if (placeInRow === 0) {
      return '0px 8px 0px 0px';
    } else if (placeInRow > 0 && placeInRow < itemsPerRow - 1) {
      return '0px 8px';
    } else if (placeInRow === itemsPerRow - 1) {
      return '0px 0px 0px 8px';
    }
    return '0px';
  }

  return (
    <Box
      className="featureBenefitItem"
      sx={classes.benefitItem}
      margin={{ xxs: '0px 0px 16px', sm: getMargin(index) }}
    >
      <div style={{ display: 'flex' }}>
        <div style={{ marginRight: '8px', marginTop: '-2px' }}>
          <Typography fontSize={'18px'}>
            {categoryBenefitsMap[benefit.category]?.icon}
          </Typography>
        </div>
        <Typography sx={classes.benefitsCategoryText}>
          {benefit.category}
        </Typography>
      </div>
      <Typography sx={classes.benefitsDetailsText}>
        {formatDetails(benefit.details)}
      </Typography>
    </Box>
  );
};

export default BenefitCard;
